import { createSelector } from 'reselect'

export const getFormError = createSelector(
  state => state && state.common && state.common.form && state.common.form.error
    ? state.common.form.error : null,
  error => error
)
